module.exports = new __parcel__URL__("empty.620028f9.png").toString();